export default [
  {
    path: '/recycle',
    name: 'apps-recycle',
    component: () => import('@/views/recycle/Recycle.vue'),
  },
  ]